var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{staticStyle:{"display":"none"},attrs:{"width":"0","height":"0"},domProps:{"innerHTML":_vm._s(_vm.svgSprite)}})
}
var staticRenderFns = []

export { render, staticRenderFns }